import React from 'react';
import { Instagram, Facebook, MapPin, Star } from 'lucide-react';
import { FOOTER } from '@/constants/testIds';
import Logo from './Logo';

const cols = [
  {
    title: 'Collections',
    links: ['Bridal Wear', 'Wedding Guest', 'Party Wear', 'Kids Collection', 'Men’s Collection'],
  },
  {
    title: 'Categories',
    links: ['Lehengas', 'Sarees', 'Salwar Suits', 'Anarkali', 'Sharara Sets', 'Jewelry & Accessories'],
  },
  {
    title: 'Boutique',
    links: ['About', 'Why Choose Us', 'Appointments', 'Tailoring', 'Contact', 'FAQ'],
  },
];

export const Footer = () => (
  <footer data-testid={FOOTER.root} className="bg-charcoal text-ivory relative overflow-hidden">
    <div className="container-luxe py-20 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <div className="flex items-center gap-3">
          <Logo size="md" />
          <div className="font-display text-2xl">Trendy Closet</div>
        </div>
        <p className="mt-5 text-ivory/65 leading-relaxed text-sm max-w-sm">
          Est. 2020 · Elegant Indian fashion for every celebration — proudly women & Asian-owned, serving the
          Triangle area from Morrisville, NC.
        </p>

        <div className="mt-6 flex items-center gap-2">
          {[...Array(5)].map((_, i) => (<Star key={i} className="w-4 h-4 fill-gold text-gold" />))}
          <a
            href="https://www.google.com/search?q=Trendy+Closet+Indian+Clothing+Reviews"
            target="_blank" rel="noreferrer"
            className="ml-2 text-xs text-ivory/70 underline-offset-4 hover:text-gold hover:underline"
          >
            5.0 · Google Reviews
          </a>
        </div>

        <div className="mt-6 flex gap-3">
          <a href="https://instagram.com/trendyclosetnc/" target="_blank" rel="noreferrer" aria-label="Instagram" className="w-10 h-10 border border-ivory/20 hover:bg-gold hover:border-gold hover:text-charcoal flex items-center justify-center transition-all"><Instagram className="w-4 h-4" /></a>
          <a href="https://www.facebook.com/Trendycloset2020" target="_blank" rel="noreferrer" aria-label="Facebook" className="w-10 h-10 border border-ivory/20 hover:bg-gold hover:border-gold hover:text-charcoal flex items-center justify-center transition-all"><Facebook className="w-4 h-4" /></a>
        </div>
      </div>

      {cols.map((c) => (
        <div key={c.title} className="lg:col-span-2">
          <div className="overline text-gold">{c.title}</div>
          <ul className="mt-5 space-y-3">
            {c.links.map((l) => (
              <li key={l}>
                <a href="#collections" className="text-sm text-ivory/70 hover:text-gold transition-colors">{l}</a>
              </li>
            ))}
          </ul>
        </div>
      ))}

      <div className="lg:col-span-2">
        <div className="overline text-gold">Visit</div>
        <div className="mt-5 text-sm text-ivory/75 leading-relaxed">
          <div className="flex gap-2 items-start"><MapPin className="w-4 h-4 mt-0.5" />158 Liberty Rose Dr<br />Morrisville, NC 27560</div>
          <a href="tel:+19843779835" className="mt-3 inline-block hover:text-gold">984-377-9835</a>
          <div className="mt-3 text-ivory/55">Open daily · 4:30 PM – 8:30 PM</div>
        </div>
      </div>
    </div>

    <div className="border-t border-ivory/10">
      <div className="container-luxe py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-ivory/55">
        <div>© {new Date().getFullYear()} Trendy Closet · All rights reserved.</div>
        <div className="flex gap-4">
          <span>Women Owned</span><span>·</span><span>Asian Owned</span><span>·</span><span>LGBTQ Friendly</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
